module.exports = "https://cwa.roocdn.com/_next/static/customer.39c9cacd.png";